export default __webpack_public_path__ + "static/startup-badge-41dd22a4361cfc6d0c37bf7ea1ef3b05.png";